import React from 'react';
import {PropTypes} from 'prop-types';
import {observer} from 'mobx-react';
import {observable, action, makeObservable} from 'mobx';
import AppStatusIndicator from '../app-status-indicator/app-status-indicator';

@observer
export default class AppEditNavigator extends React.Component {

  constructor(props) {
    super(props);
    makeObservable(this);
  }

  static propTypes = {
    name: PropTypes.string,
    status: PropTypes.string
  };

  @observable editableSectionsList = [
    {
      landmark: 'desc_version',
      displayName: 'Descriptions &amp; Version Details'
    }, {
      landmark: 'search_filter_criteria',
      displayName: 'Search &amp; Filter Criteria'
    }, {
      landmark: 'developer_info',
      displayName: 'Developer Information'
    }, {
      landmark: 'store_pkg_info',
      displayName: 'Store &amp; Package Information'
    }, {
      landmark: 'app_images',
      displayName: 'Images'
    }
  ];

  @observable activeSection = this.editableSectionsList[0].landmark;

  @action setActiveEditSection(section) {
    this.activeSection = section;
  }

  @action setTopPosition(indexPos) {
    this.editableSectionsList[indexPos].top
  }

  componentDidMount() {
    document.addEventListener('scroll', this.trackActiveSection, false);
    window.addEventListener('resize', this.setPageLandmarks, false);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.trackActiveSection, false);
    window.removeEventListener('resize', this.setPageLandmarks, false);
  }

  setPageLandmarks = () => {
    this.editableSectionsList.forEach((element) => {
      let topPos= document.getElementById(element.landmark).getBoundingClientRect().top + window.pageYOffset;
      element.top = topPos;
    });
  }

  //defining "active" section being that the top of the viewport is within the section's bounds
  trackActiveSection = () => {
    if (document.querySelector('.edit-app') !== null) {
      //if initial positions havent been set, set them
      if (!this.editableSectionsList[0].top) {
        this.setPageLandmarks();
      }

      const topPos = document.documentElement.scrollTop || document.body.scrollTop;

      for (let i = this.editableSectionsList.length; (i - 1) >= 0; i--) {
        if (topPos >= this.editableSectionsList[i - 1].top) {
          this.setActiveEditSection(this.editableSectionsList[i - 1].landmark);
          break;
        } else {
          this.setActiveEditSection(this.editableSectionsList[0].landmark);
        }
      }
    }
  };

  handleScrollTo = elementId => {
    const element = document.querySelector('#' + elementId);
    element.scrollIntoView();
    element.querySelectorAll('h3')[0].focus();
  };

  renderJumpLinks = () => {
    return (this.editableSectionsList.map(linkItem => {
      return (<li key={linkItem.landmark} role="button" className={`${this.activeSection === linkItem.landmark
          ? 'active'
          : ''}`} onClick={() => {
          this.handleScrollTo(linkItem.landmark)
        }}>
        <span dangerouslySetInnerHTML={{
            __html: linkItem.displayName
          }}/>
      </li>)
    }))
  }

  render() {
    return (<nav className="app-edit-navigator">
      <h5>{this.props.name}</h5>
      <AppStatusIndicator status={this.props.status} />
      <h6>App Details:</h6>
      <ul>
        {this.renderJumpLinks()}
      </ul>
    </nav>);
  }
}
